import { alias, AliasedConstructor } from '../../rest/decorators/alias'
import {
  Serialisable,
  SerialisationConfig,
} from '../../rest/utilities/serialisable'

export class JobStatus extends Serialisable {
  public static override serialisationConfig: SerialisationConfig =
    new SerialisationConfig(() => new JobStatus())

  @alias('name')
  name!: string
  @alias('slug')
  slug!: string
  @alias('colour')
  colour!: string

  constructor() {
    super((JobStatus as unknown as AliasedConstructor)._alias)
  }

  get colourSlug(): string {
    return this.colour ? this.colour.replace('_', '-') : ''
  }

  static create<Data>(attrs: Data) {
    return new JobStatus().update(attrs, JobStatus.serialisationConfig)
  }
}
